"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _addScript = _interopRequireDefault(require("../lib/hooks/addScript"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var OnDemandScripts = props => {
  if (props && props.scriptList) {
    if (typeof document !== 'undefined') {
      return (0, _lodash.map)(props.scriptList, src => {
        var scriptSrc = src.fields.Value.value;
        {
          !(0, _lodash.isEmpty)(scriptSrc) && (0, _addScript.default)(scriptSrc);
        }
      });
    } else {
      return null;
    }
  } else {
    return null;
  }
};
var _default = exports.default = OnDemandScripts;